import { Directive, ElementRef, forwardRef, HostListener, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EventBus, EventBusBase } from '@skylab-angular-shared/core';
import { dateDiffInDays, isDate } from '@skylab-shared/utils';
import { format } from 'fecha';
import { ValueAccessor } from './value-accessor';

@Directive({
    selector: 'ins-datepicker',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerValueAccessorDirective),
            multi: true,
        },
    ]
})
export class DatepickerValueAccessorDirective extends ValueAccessor {
    private readonly controlDateFormat = 'YYYY-MM-DD';
    private readonly yearRange = { min: 1753, max: 9999 };

    public constructor(
        elm: ElementRef,
        @Inject(EventBus) eventBus: EventBusBase
    ) {
        super(elm, eventBus);
    }

    public override writeValue(value: any): void {
        this.currentValue = value;
        this.element.value = isDate(value) ? format(value, this.controlDateFormat) : value;
    }


    @HostListener('insBlur', ['$event.target'])
    @HostListener('insChange', ['$event.target'])
    protected handleInputEvent(elm: any): void {
        if (!elm.value) {
            this.handleChangeEvent(elm, null);
        } else {
            let date = new Date(elm.value);
            if (!this.currentValue || dateDiffInDays(date, this.currentValue) !== 0) {
                const dateYear = date.getFullYear();
                const isOutOfRange = (dateYear < this.yearRange.min) || (dateYear > this.yearRange.max);
                if (isOutOfRange) {
                    date = new Date(this.currentValue);
                    setTimeout(() => { this.element.value = format(date, this.controlDateFormat) });
                };

                this.handleChangeEvent(elm, date);
            }
        }
    }
}
